import React from "react";
import { useId } from "react";
import "./SscIamInput.scss";

export const SscIamInput = ({ label, type = "text", errorMessage, value, onChange }) => {
  const id = useId();

  return (
    <div className="ssciam-input-root">
      <div className="ssciam-input-label">
        <label htmlFor={id}>{label}</label>
      </div>
      <input className="ssciam-input" type={type} value={value} onChange={(e) => onChange(e.target.value)} id={id} />
      <InputError errorMessage={errorMessage} />
    </div>
  );
};

const InputError = ({ errorMessage }) => {
  return (
    <div className="ssciam-input-error">{errorMessage && errorMessage.length > 0 && <>{`${errorMessage}`}</>}</div>
  );
};
